export default String.raw`
.footer {
    padding: 16px 16px 32px;
    &__main {
        display: flex;
        flex-direction: column;
        gap: unset;
    }
    &__section {
        max-width: 100%;
        &-title {
            padding: 16px 0;
            &.switch {
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-bottom: 1px solid $footerColorFont;
                cursor: pointer;
            }
            span {
                width: 100%;
            }
        }
        &-arrow {
            display: block;
            fill: $footerColorFont;
            margin-left: 10px;
            transition: transform 0.5s ease-out;
            &.rotate {
                transform: rotate(180deg);
            }

            &:focus-visible {
                outline-offset: -1px !important;
            }
        }
        &-content.to-hide {
            display: none;
        }
        &.contact-section .footer__section-title {
            padding: 24px 0 0;
        }
    }
    &__banners {
        border-top: 1px solid $footerColorFont;
    }
    &__banner {
        margin: 16px 0;
        &-title {
            width: 100%;
            margin-bottom: 16px;
        }
    }
    .hide-on-mobile {
        display: none;
    }
}
`